import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17bdbe05"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "processJobsBoard" }
const _hoisted_2 = { class: "white-background" }
const _hoisted_3 = { class: "float-end mt-4 pt-3 text-right" }
const _hoisted_4 = { class: "float-end me-4 pt-1" }
const _hoisted_5 = { class: "mt-2" }
const _hoisted_6 = { class: "display-type" }
const _hoisted_7 = { class: "item active" }
const _hoisted_8 = { class: "page h-100" }
const _hoisted_9 = { class: "row h-100" }
const _hoisted_10 = { class: "col-md-4 h-100" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "In-Active", -1))
const _hoisted_12 = { class: "scroll-wrapper pe-2" }
const _hoisted_13 = { class: "col-md-4 h-100" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Active", -1))
const _hoisted_15 = { class: "scroll-wrapper pe-2" }
const _hoisted_16 = { class: "col-md-4 h-100" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Done", -1))
const _hoisted_18 = { class: "scroll-wrapper pe-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_arrow_icon = _resolveComponent("arrow-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_context_menu = _resolveComponent("context-menu")!
  const _component_feather_icon = _resolveComponent("feather-icon")!
  const _component_help_tooltip = _resolveComponent("help-tooltip")!
  const _component_job_element_wrapper = _resolveComponent("job-element-wrapper")!
  const _component_task_job_modal = _resolveComponent("task-job-modal")!
  const _component_task_basic_add_modal = _resolveComponent("task-basic-add-modal")!
  const _component_task_delete_modal = _resolveComponent("task-delete-modal")!
  const _component_task_update_modal = _resolveComponent("task-update-modal")!
  const _component_job_add_modal = _resolveComponent("job-add-modal")!
  const _component_job_update_modal = _resolveComponent("job-update-modal")!
  const _component_job_delete_modal = _resolveComponent("job-delete-modal")!
  const _component_update_project_modal = _resolveComponent("update-project-modal")!
  const _component_delete_project_modal = _resolveComponent("delete-project-modal")!
  const _component_share_project_modal = _resolveComponent("share-project-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "decoration-none back-link",
        to: { name: 'projects' }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_arrow_icon, {
            id: "arrow-back",
            color: "paleBlue"
          }),
          _createTextVNode(" Back to all projects")
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_context_menu, {
          class: "float-end",
          icon: "more-vertical",
          id: "show-project",
          size: "18",
          links: [
            {
              text: 'Rename',
              icon: 'edit',
              bsTarget: '#updateProjectModal',
            },
            {
              text: 'Delete',
              icon: 'trash-2',
              bsTarget: '#deleteProjectModal',
            },
          ]
        }),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_feather_icon, {
            type: "share-2",
            class: "cursor-pointer icon",
            size: "16",
            "data-bs-toggle": "modal",
            "data-bs-target": "#shareProjectModal"
          })
        ])
      ]),
      _createElementVNode("h1", _hoisted_5, [
        _createTextVNode(_toDisplayString(_ctx.project.name) + " ", 1),
        _createElementVNode("a", {
          target: "_blank",
          class: "preview-link",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToProject && _ctx.goToProject(...args)))
        }, [
          _createVNode(_component_feather_icon, {
            type: "eye",
            class: "cursor-pointer icon",
            size: "24"
          }),
          _createVNode(_component_help_tooltip, {
            text: "View on client workspace",
            noIcon: "true"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_feather_icon, {
            type: "columns",
            class: "cursor-pointer",
            size: "16"
          }),
          _createTextVNode(" Board view ")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_job_element_wrapper, {
              model: _ctx.inActiveJobs,
              "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inActiveJobs) = $event)),
              title: "Inactive Jobs",
              type: "inActiveJobs",
              onSetSelectedJob: _ctx.setSelectedJob,
              onSetSelectedTask: _ctx.setSelectedTask
            }, null, 8, ["model", "onSetSelectedJob", "onSetSelectedTask"])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_job_element_wrapper, {
              model: _ctx.activeJobs,
              "onUpdate:model": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeJobs) = $event)),
              title: "Active Jobs",
              type: "activeJobs",
              onSetSelectedJob: _ctx.setSelectedJob,
              onSetSelectedTask: _ctx.setSelectedTask
            }, null, 8, ["model", "onSetSelectedJob", "onSetSelectedTask"])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_job_element_wrapper, {
              model: _ctx.doneJobs,
              "onUpdate:model": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.doneJobs) = $event)),
              title: "Completed Jobs",
              type: "doneJobs",
              onSetSelectedJob: _ctx.setSelectedJob,
              onSetSelectedTask: _ctx.setSelectedTask
            }, null, 8, ["model", "onSetSelectedJob", "onSetSelectedTask"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_task_job_modal, { onAdded: _ctx.addTask }, null, 8, ["onAdded"]),
    _createVNode(_component_task_basic_add_modal, { onAdded: _ctx.addTask }, null, 8, ["onAdded"]),
    _createVNode(_component_task_delete_modal, {
      onDeleted: _ctx.deleteTask,
      task: _ctx.selectedTask
    }, null, 8, ["onDeleted", "task"]),
    _createVNode(_component_task_update_modal, {
      onUpdated: _ctx.updateTask,
      task: _ctx.selectedTask
    }, null, 8, ["onUpdated", "task"]),
    _createVNode(_component_job_add_modal, { onAdded: _ctx.addJob }, null, 8, ["onAdded"]),
    _createVNode(_component_job_update_modal, {
      onUpdated: _ctx.updateJob,
      job: _ctx.selectedJob
    }, null, 8, ["onUpdated", "job"]),
    _createVNode(_component_job_delete_modal, {
      onDeleted: _ctx.deleteJob,
      job: _ctx.selectedJob
    }, null, 8, ["onDeleted", "job"]),
    _createVNode(_component_update_project_modal, {
      projectId: _ctx.$route.params.projectId,
      onReload: _ctx.load
    }, null, 8, ["projectId", "onReload"]),
    _createVNode(_component_delete_project_modal, {
      projectId: _ctx.$route.params.projectId,
      onReload: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/project/')))
    }, null, 8, ["projectId"]),
    _createVNode(_component_share_project_modal, { onReload: _ctx.load }, null, 8, ["onReload"])
  ]))
}